import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, tap, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class OperatoriService {
    private token!: string;
    private httpOptions: any;

    private basePath = environment.interop.basePath;
    private getOperatoriUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.operatori.getOperatori;
    private getOperatoriFilteredUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.operatori.getOperatoriFiltered;
    private updateOperatorUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.operatori.updateOperator;
    private changeStatusActiveUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.operatori.changeStatusOperatorActive;
    private changeStatusPublicUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.operatori.changeStatusOperatorPublic;
    private getPermisiuniListUrl = this.basePath + environment.interop.platform.nomenclatoare.ghiseulUnic.operatori.getOperatorPermisiuniList;

    constructor(private http: HttpClient) { }

    getOperatori(id_directie?: number, id_compartiment?: number) {
        const payload = {
            filters: {
                directie: id_directie && id_directie !== -1 ? id_directie : null,
                compartiment: id_compartiment && id_compartiment !== -1 ? id_compartiment : null,
            }
        }

        return this.http
            .post<{ errors: boolean; data: any[]; status_code: number }>(this.getOperatoriUrl, payload, this.httpOptions)
            .pipe(
                map((response: any) =>
                    response.data.map((item: any) => ({
                        id: item.id_user,
                        name: item.name
                    }))
                ),
                catchError((error) => {
                    console.error('Error in getOperatori:', error);
                    return throwError(error);
                })
            );
    }

    getOperatoriFiltered(filter?: {
        directie_id?: number,
        compartiment_id?: number,
        active?: boolean,
        public_view?: boolean,
    }) {
        const payload = {
            serviciu_directie_id: filter && filter.directie_id && filter.directie_id !== -1 ? filter.directie_id : null,
            serviciu_compartiment_id: filter && filter.compartiment_id && filter.compartiment_id !== -1 ? filter.compartiment_id : null,
            active: filter && filter.active ? filter.active : null,
            public_view: filter && filter.public_view ? filter.public_view : null,
        }

        return this.http
            .post<{ errors: boolean; data: any[]; status_code: number }>(this.getOperatoriFilteredUrl, payload, this.httpOptions)
            .pipe(
                map((response: any) =>
                    response.data.map((item: any) => ({
                        id: item.id_user,
                        name: item.name
                    }))
                ),
                catchError((error) => {
                    console.error('Error in getOperatoriFiltered:', error);
                    return throwError(error);
                })
            );
    }

    updateOperator(id: number, data: any) {
        return this.http.post(this.updateOperatorUrl + id, data, this.httpOptions);
    }

    changeStatuseActive(id: number) {
        return this.http.put(this.changeStatusActiveUrl + id, {}, this.httpOptions);
    }

    changeStatusePublic(id: number) {
        return this.http.put(this.changeStatusPublicUrl + id, {}, this.httpOptions);
    }

    getPermisiuniList(id: number) {
        return this.http.get(this.getPermisiuniListUrl + id, this.httpOptions);
    }

    setToken(token: string) {
        this.token = token;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: `Bearer ${this.token}`,
            }),
        };
    }
}
